<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-btn-toggle v-model="displayMode">
          <!-- <v-btn flat value="Summary">Summary</v-btn> -->
          <div v-if="!omit">
            <div v-if="wo.structure">
              <v-btn flat value="Inventory">Inventory</v-btn>
              <v-btn flat value="Structure">Structure</v-btn>
            </div>
          </div>
          <v-btn v-if="wo.id > 0" flat value="Assets">Assets</v-btn>
        </v-btn-toggle>
      </v-flex>
    </v-layout>
    <br />
    <div v-if="displayMode === 'Assets' & wo.id > 0">
      <v-toolbar>
        <v-toolbar-title>Allocated Assets</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <Assets :wo="wo" :reservations="wo.Reservations"></Assets>
    </div>
    <div v-if="displayMode === 'Inventory'">
      <v-toolbar>
        <v-toolbar-title>Inventory</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="setToDerivedClicked">Undo Inv Mods</v-btn>
        <v-btn @click="inventoryUpdated" v-if="inventoryChangeMade">Save new Inventory</v-btn>
      </v-toolbar>
      <v-container>
        <v-layout row>
          <v-layout column>
            <v-data-table :headers="headers" :items="volumesLeft" hide-actions>
              <template slot="items" slot-scope="props">
                <td>{{props.item.vessel}}</td>
                <td>
                  <input size="10" v-model.number="props.item.value" />
                </td>
              </template>
            </v-data-table>
          </v-layout>
          <v-layout column>
            <v-data-table :headers="headers" :items="volumesRight" hide-actions>
              <template slot="items" slot-scope="props">
                <td>{{props.item.vessel}}</td>
                <td>
                  <input size="10" v-model.number="props.item.value" />
                </td>
              </template>
            </v-data-table>
          </v-layout>
        </v-layout>
        <v-layout row>
          <v-layout column>
            <v-data-table :headers="headers" :items="volumesBottom" hide-actions>
              <template slot="items" slot-scope="props">
                <td>{{props.item.vessel}}</td>
                <td>
                  <input size="10" v-model.number="props.item.value" />
                </td>
              </template>
            </v-data-table>
          </v-layout>
        </v-layout>
      </v-container>
    </div>
    <!-- <div v-if="displayMode === 'Summary'">
      <v-toolbar>
        <v-toolbar-title>Summary</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <br />
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">Vintage:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ $store.state.vintage }}</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">ClientCode:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ $store.state.client.CODE }}</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">Client:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ $store.state.client.CLIENTNAME }}</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">Lot:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ wo.Lot.lotNumber }}</div>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs3>
          <h4 class="text-xs-left">Lot Name:</h4>
        </v-flex>
        <v-flex xs>
          <div class="text-xs-right">{{ wo.Lot.description }}</div>
        </v-flex>
      </v-layout>
    </div> -->
    <div v-if="displayMode === 'Structure'">
      <v-toolbar>
        <v-toolbar-title>Lot Structure</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <br />
      <v-layout row>
        <v-layout column>STATE: {{ wo.structure.state }}</v-layout>
      </v-layout>
      <br>
      <table>
        <tr v-for="item in wo.structureTree" :key="item">
          <td valign="top">{{item.name}}</td>
          <td>
            <table>
              <tr v-for="s in item.children" :key="s">
                <td valign="top">{{s.name}}</td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
      <!-- <v-treeview open-all :items="wo.structureTree"></v-treeview> -->
    </div>
    <div v-if="displayMode === 'Text'">
      <v-toolbar>
        <v-toolbar-title>Lot Structure</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-textarea :value="structureText"></v-textarea>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import myMixins from '../mixins/myMixins'
import Assets from './Assets.vue'
export default {
  components: {
    Assets
  },
  props: ['wo', 'omit'], // primaryLot is the lot of the parent workorder. we need to know this to prevent unselecting that lot.
  data () {
    return {
      displayMode: 'Inventory',
      total: 0,
      inventoryChangeMade: false,
      isNonUserAction: true,
      headers: [
        { text: 'Vessel', sortable: false, value: 'vessel', width: '50%' },
        { text: 'Value', sortable: false, value: 'value', width: '20%' }
      ],
      volumes: [
        { vessel: 'Tank', derived: 0, value: 0 },
        { vessel: 'BBLS', derived: 0, value: 0 },
        { vessel: 'Topping', derived: 0, value: 0 },
        { vessel: '1/2 BBLS', derived: 0, value: 0 },
        { vessel: 'Hogsheads', derived: 0, value: 0 }
      ],
      volumesLeft: [
        { vessel: 'Tank', derived: 0, value: 0 },
        { vessel: 'BBLS', derived: 0, value: 0 },
        { vessel: 'Topping', derived: 0, value: 0 },
        { vessel: '1/2 BBLS', derived: 0, value: 0 },
        { vessel: 'Hogsheads', derived: 0, value: 0 }
      ],
      volumesRight: [
        { vessel: 'Puncheons 300L', derived: 0, value: 0 },
        { vessel: 'Puncheons 400L', derived: 0, value: 0 },
        { vessel: 'Puncheons 500L', derived: 0, value: 0 },
        { vessel: 'Puncheons 600L', derived: 0, value: 0 },
        { vessel: 'SS Drums 55', derived: 0, value: 0 },
        { vessel: 'SS Drums 75', derived: 0, value: 0 }
      ],
      volumesBottom: [
        { vessel: '(Inventory Adjustment)', derived: 0, value: 0 },
        { vessel: 'Total', derived: 0, value: 0 }
      ]
    }
  },
  mixins: [myMixins],
  watch: {
    haveStruct: {
      handler: function (nv, ov) {
        this.setToDerivedClicked()
      }
    },
    volumesLeft: {
      handler: function (nv, ov) {
        // we only want this set if the data changes from a user action, not programmatically
        if (!this.isNonUserAction) {
          this.inventoryChangeMade = true
        }
        this.isNonUserAction = false
        this.calcInventoryTotal()
      },
      deep: true
    },
    volumesRight: {
      handler: function (nv, ov) {
        // we only want this set if the data changes from a user action, not programmatically
        if (!this.isNonUserAction) {
          this.inventoryChangeMade = true
        }
        this.isNonUserAction = false
        this.calcInventoryTotal()
      },
      deep: true
    },
    volumesBottom: {
      handler: function (nv, ov) {
        // we only want this set if the data changes from a user action, not programmatically
        if (!this.isNonUserAction) {
          this.inventoryChangeMade = true
        }
        this.isNonUserAction = false
        this.calcInventoryTotal()
      },
      deep: true
    },
    wo: {
      handler: function (nv, ov) {
        this.$emit('woChanged', this.wo)
      },
      deep: true
    }
  },
  created () {
    this.calcInventoryTotal()
    if (this.wo.type === 'SCP') {
      this.displayMode = 'Assets'
    }
  },
  methods: {
    calcInventoryTotal () {
      const gallonsPerLiter = 0.2642
      var result = this.volumesLeft[0].value * 1
      result += this.volumesLeft[1].value * 60
      result += this.volumesLeft[2].value * 1 // multiply by 1 to make it use value as a number
      result += this.volumesLeft[3].value * 30
      result += this.volumesLeft[4].value * 15
      result += this.volumesRight[0].value * 300 * gallonsPerLiter
      result += this.volumesRight[1].value * 400 * gallonsPerLiter
      result += this.volumesRight[2].value * 500 * gallonsPerLiter
      result += this.volumesRight[3].value * 600 * gallonsPerLiter
      result += this.volumesRight[4].value * 55
      result += this.volumesRight[5].value * 75
      result -= this.volumesBottom[0].value * 1
      this.total = result
      this.volumesBottom[1].value = result
    },
    save () {},
    cancel () {},
    setToDerivedClicked () {
      this.isNonUserAction = true
      if (!this.wo.structure) {
        return
      }
      this.volumesLeft[0].value = this.wo.structure.volume.tank
      this.volumesLeft[1].value = this.wo.structure.volume.bbls
      this.volumesLeft[2].value = this.wo.structure.volume.topping
      this.volumesLeft[3].value = this.wo.structure.volume.half_bbls
      this.volumesLeft[4].value = this.wo.structure.volume.hogsHeads
      this.volumesRight[0].value = this.wo.structure.volume.puncheons.L_300
      this.volumesRight[1].value = this.wo.structure.volume.puncheons.L_400
      this.volumesRight[2].value = this.wo.structure.volume.puncheons.L_500
      this.volumesRight[3].value = this.wo.structure.volume.puncheons.L_600
      this.volumesRight[4].value = this.wo.structure.volume.ss_drums_55
      this.volumesRight[5].value = this.wo.structure.volume.ss_drums_75
      this.volumesBottom[0].value = this.wo.structure.volume.endingInventoryAdjustment
      this.inventoryChangeMade = false
    },
    inventoryUpdated () {
      console.log('emit inventory updated')
      this.wo.endingTankGallons = this.volumesLeft[0].value
      this.wo.endingBarrelCount = this.volumesLeft[1].value
      this.wo.endingToppingGallons = this.volumesLeft[2].value
      this.wo.endingHalfBarrels = this.volumesLeft[3].value
      this.wo.endingHogsHeads = this.volumesLeft[4].value
      this.wo.endingPuncheonsL300 = this.volumesRight[0].value
      this.wo.endingPuncheonsL400 = this.volumesRight[1].value
      this.wo.endingPuncheonsL500 = this.volumesRight[2].value
      this.wo.endingPuncheonsL600 = this.volumesRight[3].value
      this.wo.endingSSDrums55 = this.volumesRight[4].value
      this.wo.endingSSDrums75 = this.volumesRight[5].value
      this.wo.endingInventoryAdjustment = this.volumesBottom[0].value
      console.log(JSON.stringify(this.wo.endingBarrelCount, null, 2))
      axios.put(
        process.env.VUE_APP_BACKEND +
          'workorders/' +
          this.wo.id,
        this.wo
      )
        .then(response => {
          console.log('save completed')
        })
      this.$emit('inventoryUpdated', this.wo)
    }
  },
  computed: {
    haveStruct () {
      return this.wo.structure
    },
    structureText () {
      return this.textDescriptionOfStructure(this.wo)
    }
  }
}
</script>

<style scoped>
/* v-treeview-node__label.fontsize = 1.0rem; */
</style>
